var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExplorer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77907 0.71254C7.52022 -0.0349077 5.95361 -0.0349159 4.69476 0.712519L1.95786 2.33753C0.74406 3.05822 0 4.36533 0 5.77696V9.22302C0 10.6346 0.744055 11.9418 1.95785 12.6624L4.69475 14.2875C5.95361 15.0349 7.52023 15.0349 8.77908 14.2874L11.5159 12.6624C12.7296 11.9418 13.4737 10.6347 13.4737 9.22304V5.77694C13.4737 4.36532 12.7296 3.05822 11.5159 2.33753L8.77907 0.71254ZM0.911655 6.33875C0.911655 5.5636 1.75543 5.08318 2.42203 5.4788L4.81221 6.89734C5.72283 7.43779 6.28109 8.41828 6.28109 9.4772V12.39C6.28109 13.1653 5.43715 13.6457 4.77056 13.2499L2.38005 11.8305C1.4697 11.29 0.911655 10.3097 0.911655 9.25097V6.33875ZM8.70329 13.2499C8.0367 13.6457 7.19275 13.1653 7.19275 12.39V9.47719C7.19275 8.41827 7.75099 7.43779 8.6616 6.89734L11.0516 5.47885C11.7182 5.08322 12.562 5.56364 12.562 6.3388V9.25102C12.562 10.3097 12.004 11.2901 11.0937 11.8306L8.70329 13.2499Z",
    fill: "#62718A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorer);
export default __webpack_public_path__ + "static/media/explorer.af88fb401bea6253905d284af8c550f3.svg";
export { ForwardRef as ReactComponent };